export const showMercuryError = (text?: string) => {
  if (!text) text = 'Не удалось получить некоторые данные от системы меркурий(ВСД). Для корректной работы обратитесь, пожалуйста, к разработчикам';
}